import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_services } from "../../../../Controllers/Services/Services";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Services/Services/tables";
import headers from "../../../../Data/Tables/Services/Services/headers";
import Loadercomponent from "../../../../Componets/Loader";

const ServiceTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      category: headerdata?.category,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      category: headerdata?.category,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        category: tabledata?.category,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const services = await get_all_services(data);
      
      if (services?.status) {
        let data = [];

        services?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/services/view/${value?._id}`,
            Name: <TableImage image={value?.image} name={value?.name} />,
            Category: value?.category?.name || "N/A",
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/services/edit/${value?._id}`}
                id={value?._id}
                api="delete-service"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: services?.data?.currentPage,
          totalCount: services?.data?.totalCount,
          totalPages: services?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(services?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ServiceTable;